import { layoutChrome } from "@maeiz/tokens";
import { DocPage, Section, SpecTable, Demo } from "../../components/DocChrome";

export function LayoutPage() {
    return (
        <DocPage
            title="Layout & Grid"
            description="Canonical Workspace chrome and page structures shared across panels."
        >
            <Section title="Application shell">
                <SpecTable
                    rows={[
                        ["Sidebar expanded", layoutChrome.sidebarExpanded],
                        ["Sidebar collapsed", layoutChrome.sidebarCollapsed],
                        ["Topbar", layoutChrome.topbar],
                        ["Content max", layoutChrome.contentMax],
                        [
                            "Page gutter (mobile / desktop)",
                            `${layoutChrome.pageGutterMobile} / ${layoutChrome.pageGutterDesktop}`,
                        ],
                    ]}
                />
                <p>
                    Use <code>AppShell</code> + <code>PageHeader</code> from <code>@maeiz/ui</code>.
                    Rider/Customer may use <code>BottomNav</code> on small viewports instead of a
                    persistent sidebar.
                </p>
            </Section>
            <Section title="Page archetypes">
                <Demo>
                    <ul className="grid gap-2 sm:grid-cols-2">
                        {[
                            "Dashboard",
                            "List",
                            "Detail",
                            "Create/Edit",
                            "Wizard",
                            "Settings",
                            "History",
                            "Analytics",
                        ].map((a) => (
                            <li
                                key={a}
                                className="rounded-mz-md border border-neutral-border px-3 py-2 text-sm dark:border-white/10"
                            >
                                {a}
                            </li>
                        ))}
                    </ul>
                </Demo>
            </Section>
            <Section title="Grid">
                <p>
                    Prefer 12-column mental model via Tailwind grid (`grid-cols-12`) with 16/24px
                    gutters. Forms: single column on mobile, 2 columns from `md`.
                </p>
            </Section>
        </DocPage>
    );
}
